export default __webpack_public_path__ + "static/media/AwesomeAir_07.7253a583.png";